// 简体中文文案（i18n 基准语言）。
// 这份对象的「形状」即 MessageSchema —— en.ts 必须与它结构一致，漏键会编译报错。
// 占位符用 {name} 形式，配合 t('key', { name }) 使用。

const messages = {
  common: {
    appName: "饺子云",
    appNameGlobal: "Starparks",
    confirm: "好",
    cancel: "取消",
    loginRegister: "登录 / 注册",
    userAgreement: "用户协议",
    privacyPolicy: "隐私政策",
    notBound: "未绑定",
  },
  tabbar: {
    home: "首页",
    search: "搜索",
    library: "游戏库",
    mine: "我的",
    badgeLogin: "登录",
    badgeUpgrade: "升",
  },
  login: {
    navTitle: "登录",
    welcome: "欢迎来到{brand}",
    subtitle: "手机验证码登录，或用微信 / QQ 快捷登录",
    subtitleGlobal: "免注册立即体验，或用 Google / Telegram / Facebook 登录",
    mobileLabel: "手机号",
    mobilePlaceholder: "11 位手机号",
    codeLabel: "验证码",
    codePlaceholder: "短信验证码",
    getCode: "获取验证码",
    resendIn: "{sec}s 后重发",
    agreement:
      "未注册的手机号验证后将自动创建账号，即代表同意 {userAgreement} 与 {privacyPolicy}",
    otherMethods: "其他登录方式",
    guest: "以游客身份继续",
    wechat: "微信登录",
    qq: "QQ 登录",
    google: "使用 Google 继续",
    telegram: "\u4f7f\u7528 Telegram \u7ee7\u7eed",
    facebook: "使用 Facebook 继续",
    wechatComingSoon: "微信登录即将开放",
    qqComingSoon: "QQ 登录即将开放",
    googleComingSoon: "Google 登录即将开放",
    googleFailed: "Google 登录失败，请重试",
    telegramFailed: "Telegram \u767b\u5f55\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5",
    facebookComingSoon: "Facebook 登录即将开放",
    mobileInvalid: "请输入正确的手机号",
    codeInvalid: "请输入验证码",
    codeSent: "验证码已发送",
  },
  loginPrompt: {
    defaultMessage: "登录后查看你的游戏",
  },
  settings: {
    navTitle: "设置",
    loginPrompt: "登录后管理账号设置",
    nickname: "昵称",
    mobile: "手机号",
    controller: "控制器设置",
    controllerDesc: "鼠标灵敏度 / 右摇杆 / 按键互换",
    about: "关于",
    clearCache: "清除本地缓存",
    language: "语言",
    editNickname: "修改昵称",
    nicknamePlaceholder: "新昵称",
    nickEmpty: "昵称不能为空",
    nickTooLong: "昵称最多 16 个字",
    updated: "已更新",
    cacheCleared: "已清除，请重新登录",
    aboutTitle: "关于{brand}",
    aboutVersion: "Web 版本 v{version}",
    aboutBody:
      "云游戏服务，让你随时随地在浏览器里玩 3A 大作。\n所有游戏内容版权归原厂商所有。",
  },
  subscription: {
    choosePlan: "选择套餐",
    included: "包含权益",
    orderSummary: "订单摘要",
    total: "合计",
    continue: "继续",
    secureNote: "安全支付 · 一次性购买",
    navTitle: "升级会员",
    unlockTitle: "解锁会员特权",
    expired: "已过期",
    daysLeft: "剩 {days} 天",
    validUntil: "有效期至 {time}",
    tagline: "无排队、更长时长、更高画质",
    perDay: "约 {price}/天",
    recommended: "推荐",
    currentLevel: "当前等级",
    footer:
      "本商品为一次性会员购买。支付确认后增加所选会员天数，不会自动续费。",
    planVipMonth: "VIP 月卡",
    planSvipMonth: "SVIP 月卡",
    perkNoQueue: "免排队进入",
    perkDailyFree: "每日免费游戏 60 分钟",
    perkHd: "高清画质",
    perkAllVip: "VIP 全部特权",
    perkUnlimited: "无限游戏时长",
    perk4k: "4K 画质 / 60fps",
    perkSupport: "专属客服",
    cnPayComingSoon: "Web 端微信 / 支付宝支付即将开放，请暂用 App 完成购买",
    intlPayComingSoon: "Stripe / PayPal 网页支付即将开放",
    payProcessing: "请完成支付并保持本页面打开…",
    paySuccess: "支付成功，会员已开通",
    payFailed: "支付失败，请稍后重试",
    payCancelled: "已取消支付",
    telegramExtraTimeUnavailable: "Telegram 内的游戏时长购买将在接入 Stars 版本后开放。",
    payUnconfirmed: "未检测到支付完成；如已付款，将于稍后自动到账",
    payPopupBlocked: "浏览器拦截了支付窗口，请允许弹出窗口后重试",
    loadPlansFailed: "套餐加载失败，请重试",
    retry: "重试",
  },
  app: {
    backToDesktop: "切回电脑版",
  },
  titles: {
    home: "首页",
    search: "搜索",
    detail: "游戏详情",
    library: "游戏库",
    category: "分类",
    mine: "我的",
    myGames: "我的游戏",
    reviews: "玩家评价",
    gameVideos: "实况视频",
    commentReplies: "评论详情",
    saves: "游戏存档",
    subscription: "升级会员",
    signIn: "每日签到",
    settings: "设置",
    controlSettings: "控制器设置",
    login: "登录",
    play: "进入游戏",
  },
  home: {
    searchPlaceholder: "搜索游戏",
    sectionDefault: "游戏",
    allGames: "全部游戏",
    more: "更多",
    empty: "暂无内容",
    latestOnline: "最新上线",
    comingSoon: "敬请期待",
    subscribe: "预约",
    subscribed: "已预约",
    score: "评分",
    subscribeSuccess: "预约成功，上线后通知你",
  },
  nav: {
    home: "首页",
    library: "游戏库",
    searchPlaceholder: "搜索游戏",
    me: "我",
    guest: "游客",
    profile: "个人中心",
    myGames: "我的游戏",
    dailyCheckIn: "每日签到",
    renewMembership: "续费会员",
    upgradeMembership: "升级会员",
    settings: "设置",
    switchToMobile: "切换到手机版",
    logout: "退出登录",
    logoutConfirm: "确认要退出吗？",
    mobileVersion: "手机版",
    login: "登录",
  },
  library: {
    all: "全部",
    noMore: "没有更多了",
    loading: "加载中…",
    noData: "暂无数据",
    noGames: "暂无游戏",
    noUpcoming: "暂无即将上线的游戏",
    emptyCategory: "该分类暂无游戏",
  },
  mine: {
    notLoggedIn: "未登录",
    loginSyncTip: "登录后同步会员、收藏与游戏记录",
    loginSyncTipDesktop: "登录后查看个人资料、会员、签到与游戏记录",
    guest: "游客",
    daysLeft: "剩 {n} 天",
    expired: "已过期",
    renewBanner: "您的 {level} 还有 {n} 天到期，续费享 7 折",
    membershipExpiredRenew: "您的会员已过期，立即续费",
    membershipExpired: "会员已过期",
    membershipDaysLeft: "会员剩 {n} 天",
    gameTime: "游戏时长",
    minUnit: "分",
    dailyCheckIn: "每日签到",
    upgrade: "升级",
    renew: "续费",
    upgradeMembership: "升级会员",
    renewMembership: "续费会员",
    membership: "会员",
    myCollection: "我的收藏",
    collectedGames: "收藏的游戏",
    recentlyPlayed: "最近玩过",
    gameHistory: "游戏历史",
    settings: "设置",
    switchToDesktop: "切换到电脑版",
    accountAndPrefs: "账号与偏好",
    claimGameTime: "领游戏时长",
    bindPhone: "绑定手机号",
    bindPhoneDesc: "升级为正式账号，跨设备同步",
    bindPhoneDescDesktop: "升级正式账号，跨设备同步",
    resetGuest: "重置游客身份",
    resetGuestDesc: "清除当前游客账号，以新身份重新进入",
    resetGuestDescDesktop: "以新身份重新进入",
    logout: "退出登录",
    myGamesTitle: "我的游戏",
    collectTab: "收藏",
    loginViewCollect: "登录后查看你收藏的游戏",
    noCollect: "还没收藏任何游戏",
    loginViewHistory: "登录后查看游戏记录",
    noHistory: "最近还没玩过游戏",
    weekMon: "周一",
    weekTue: "周二",
    weekWed: "周三",
    weekThu: "周四",
    weekFri: "周五",
    weekSat: "周六",
    weekSun: "周日",
    alreadySignedToday: "今天已签到",
    signSuccessReward: "签到成功！+{n} 分钟",
    signSuccess: "签到成功",
    loginJoinCheckIn: "登录后参与每日签到",
    claimed: "已领",
    unclaimed: "未领",
    todayDone: "今日✓",
    today: "今日",
    dayN: "第 {n} 天",
    signedToday: "今日已签到",
    signNow: "立即签到",
    checkInTip1: "每日签到可领取免费游戏时长。",
    checkInTip2: "漏签的天数可在补签页面用金币补回。",
    loggedOut: "已退出",
    resetGuestConfirm:
      "将清除当前游客账号并以新身份重新进入，已购买的订阅、收藏、历史都会丢失。确认继续？",
    resetGuestConfirmBtn: "确认重置",
    resetting: "重置中…",
    resetDone: "已重置，请重新登录",
  },
  reviews: {
    recommendRate: "好评率",
    tooFew: "评价人数较少",
    count: "{n} 条评价",
    playFirst: "玩过游戏才能发表评价",
    rateThis: "玩过这款游戏，给个评价吧",
    mine: "我的",
    edit: "编辑",
    delete: "删除",
    report: "举报",
    played: "玩了 {d}",
    contentEmpty: "评价内容不能为空",
    editReview: "编辑评价",
    editDone: "已更新",
    published: "评价已发布",
    deleteTitle: "删除评价？",
    deleteConfirm: "删除后无法恢复，确认删除这条评价？",
    deleted: "已删除",
    reportTitle: "举报",
    reportConfirm: "确认举报这条内容？审核团队会处理。",
    reported: "已举报",
    deleteReplyTitle: "删除回复？",
    deleteReplyConfirm: "确认删除这条回复？",
    replyTo: "回复",
    viewAllReplies: "查看全部 {n} 条回复",
    loadMore: "加载更多",
    allReplies: "全部回复（{n}）",
    commentDeleted: "该评价已删除",
    commentShielded: "该评价已被屏蔽",
    replyDeleted: "该回复已删除",
    replyShielded: "该回复已被屏蔽",
  },
  detail: {
    svipRequiredMsg: "该游戏需要 SVIP 资格才能游玩",
    timeInsufficientMsg: "当前游戏时长不足，请优先购买游戏时长",
    goBuy: "去购买",
    thinkAgain: "再想想",
    navTitle: "游戏详情",
    back: "返回",
    svipOnly: "SVIP 专享",
    vipOnly: "VIP 专享",
    freeMinutes: "免费 {n} 分钟",
    saveManage: "存档管理",
    saveManageDesc: "查看 / 恢复历史存档，添加备注",
    liveVideos: "实况视频",
    more: "更多",
    viewAll: "查看全部",
    viewAllCount: "查看全部 {n}",
    intro: "游戏介绍",
    screenshots: "游戏截图",
    controlMethod: "操作方式：",
    playerReviews: "玩家评价",
    commentCount: "{n} 条",
    recommend: "推荐",
    notRecommend: "不推荐",
    similarGames: "相似游戏",
    collect: "收藏",
    collected: "已收藏",
    collectStar: "☆ 收藏",
    collectedStar: "★ 已收藏",
    unfavorited: "已取消收藏",
    entering: "进入中…",
    unlockSvip: "开通 SVIP 解锁",
    unlockVip: "开通 VIP 解锁",
    startGame: "开始游戏",
    reviewCount: "{n} 条评价",
    sortHot: "热门",
    sortNew: "最新",
    noMore: "没有更多了",
    playedHours: "玩了 {n} 小时",
    report: "举报",
    reportTitle: "举报这条评论？",
    reportMessage: "审核团队会查看，确认举报？",
    reported: "已上报",
    noReviews: "还没有评论，做第一个评论的人",
    writeReview: "发表评价",
    reviewPlaceholder: "说说你的游戏体验……（至少 5 个字）",
    reviewMinLength: "评论至少 5 个字",
    reviewSubmitted: "评论已提交",
    publish: "发布",
    commentDetail: "评论详情",
    replyCount: "{n} 条回复",
    noReplies: "还没有回复，做第一个吧",
    reply: "回复",
    replyToUser: "回复 {'@'}{name}",
    saySomething: "说点什么…",
    send: "发送",
    sent: "已发送",
    videoCount: "共 {n} 个视频",
    watchCount: "{wan}万次",
    noVideos: "暂无视频",
    videoUnavailable: "该视频源暂时无法播放",
    videoUnavailableDesc: "可能是早期视频已下线，换一个试试",
  },
  search: {
    placeholder: "输入游戏名",
    emptyHint: "搜索游戏名 / 拼音",
    history: "搜索历史",
    clear: "清除",
    noResults: "没找到相关游戏",
  },
  misc: {
    savesTitle: "游戏存档",
    savesTitleNamed: "{name} - 存档",
    savesLoginPrompt: "登录后查看你的游戏存档",
    savesActiveHeading: "当前激活存档",
    savesUnnamed: "未命名存档",
    savesEditRemark: "改备注",
    savesEmpty: "还没有云端存档",
    savesEmptyHint: "游戏内保存后会自动同步到这里",
    savesHistory: "历史存档",
    savesCount: "{n} 条",
    savesCurrent: "当前",
    savesCorrupted: "损坏",
    savesRestore: "恢复",
    savesNoHistory: "没有历史存档",
    savesFooter:
      "存档由游戏内手动 / 自动保存触发，会自动同步到云端。当前不支持手动删除存档（在游戏内继续保存会自然覆盖最早的）。",
    savesRemarkTitle: "修改存档备注",
    savesRemarkPlaceholder: "给这个存档起个名字，比如「打完第一章」",
    savesSave: "保存",
    savesAlreadyCurrent: "这就是当前存档",
    savesRestoreTitle: "恢复存档",
    savesRestoreConfirm: "恢复到这条存档？下次进入游戏会从「{name}」开始。",
    savesSwitched: "已切换为当前存档",
    savesSaved: "已保存",
    ctrlNavTitle: "控制器设置",
    ctrlSave: "保存",
    ctrlIntro:
      "在这里调整鼠标 / 手柄手感。所有值留空 / 0 表示跟随每个游戏的服务端默认配置；调整后会覆盖到所有游戏。",
    ctrlMouseSensitivity: "鼠标灵敏度",
    ctrlServerDefault: "服务端默认",
    ctrlMouseHint: "锁定模式下移动距离 = 物理移动 × {n}%",
    ctrlStickSensitivity: "手柄右摇杆灵敏度",
    ctrlStickHint: "FPS / 动作游戏视角转动速度。左摇杆（移动）不受影响。",
    ctrlPrimaryClick: "鼠标主点击键",
    ctrlLeftPrimary: "左键主点",
    ctrlRightPrimary: "右键主点",
    ctrlPrimaryClickHint: "少数游戏（如部分独立游戏）默认右键开火，需要互换。",
    ctrlResetDefault: "恢复默认",
    ctrlSavedToast: "已保存，下次进入游戏生效",
    ctrlResetToast: "已恢复服务端配置",
    savesUploading: "存档上传中，请稍后再试",
    savesCheckFailed: "获取存档状态失败，请重试",
  },
  play: {
    stageReady: "准备就绪",
    queueing: "排队中",
    queueJoining: "正在加入队列…",
    queueAheadPrefix: "前面还有",
    queueAheadSuffix: "位玩家",
    queueEta: "预计 {n} 秒",
    cancelReturn: "取消，返回",
    back: "返回",
    retry: "重试",
    goSubscribe: "去开通",
    entering: "进入游戏中",
    vipCta: "开通 VIP 立即进入",
    vipPerks: "免排队 + 高清画质 + 更长时长",
    sessionExpiredHint: "会话过期通常是排队太久导致的，点「重试」会重新排队",
    lineOldUser: "老用户队列",
    lineNewbie: "新人队列",
    lineFast: "加速队列",
    lineSvip: "SVIP 专属队列",
    svipRequired: "此游戏为 SVIP 专享，请先开通 SVIP",
    stageConnectingServer: "正在连接服务器…",
    stageHandshake: "服务器握手中…",
    stageP2pNegotiating: "P2P 通道协商中…",
    stageMediaStreaming: "媒体流传输中…",
    stageWaitingFrame: "等待画面就绪…",
    stageVideoTrack: "视频轨已接收…",
    stageEntered: "已进入",
    stageConnect: "连接",
    stageConnectedSoon: "已连接，画面即将出现…",
    allocFailed: "无法分配游戏服务器",
    allocFailedHttp: "分配失败（HTTP {status}）",
    reenterHint: "（请退出后重新进入游戏）",
    errP2pFailed: "P2P 网络协商失败，请检查网络",
    errDisconnected: "连接中断（code={code}），请重试",
    errStageFailed: "{stage} 失败",
    errStageFailedDetail: "{stage} 失败：{detail}",
    errConnectTimeout: "连接超时，未能接通服务器。请检查网络后重试",
    errQueueCancelled: "排队已被服务器取消，请重试",
    errKicked: "账号已在其他设备登录，当前连接已下线",
    errCannotStart: "暂时无法开始游戏",
    registerFailed: "注册失败",
  },
  game: {
    recharge: "充值",
    tabControl: "控制",
    tabFrame: "画面",
    tabVoice: "声音",
    controlScheme: "控制方式",
    hideVirtualKeys: "隐藏虚拟按键",
    mouseMode: "鼠标模式",
    mouseModeTouchpad: "触控板",
    mouseModeDrag: "拖动",
    mouseModeDirect: "直接",
    mouseSensitivity: "鼠标灵敏度 {n}%",
    rightStickMode: "右摇杆模式",
    joyModeFixed: "固定",
    joyModeHalf: "半屏",
    joyModeFull: "全屏",
    joyModeDrag: "拖动",
    stickSensitivity: "摇杆灵敏度 {n}%",
    customLayout: "自定义按键布局",
    editLayout: "编辑布局",
    frameComingSoon: "画面缩放 / 清晰度切换将在后续版本接入。",
    gameSound: "游戏声音",
    schemeFollow: "跟随游戏",
    schemeGamepad: "手柄",
    schemeKeyMouse: "键鼠",
    schemeTouch: "触屏",
    schemeSwitchedGamepad: "已切到手柄",
    schemeSwitchedKeyMouse: "已切到键鼠",
    schemeSwitchedFollow: "已恢复跟随游戏",
    modifierTitle: "修改器",
    modifierNeedUnlock: "该修改器需购买解锁",
    usageTitle: "使用说明",
    usageEmpty: "暂无使用说明",
    gotIt: "知道了",
    close: "关闭",
    noModifiers: "暂无修改器",
    locked: "未解锁",
    needUnlock: "需购买解锁",
    remaining: "剩余 {d}",
    use: "使用",
    quitTitle: "退出游戏",
    quitConfirm: "确定要退出当前游戏吗？",
    quitConfirmBtn: "退出",
    quitCancelBtn: "继续游戏",
    joyNameFixed: "固定",
    joyNameHalfZone: "半屏热区",
    joyNameFullFollow: "全屏跟随",
    joyNameDrag: "拖动",
    padConnected: "🎮 已连接手柄，隐藏虚拟按键",
    padDisconnected: "手柄已断开，恢复虚拟按键",
    rightStickToast: "右摇杆：{name}",
    noEditableLayout: "没有可编辑的按键布局",
    timeUsedUp: "游戏时长已用完",
    addTimeSuccess: "加时成功",
    submitted: "已提交",
    minutesShort: "{n}分",
    addTime: "加时",
    expand: "展开",
    collapse: "收起",
    physicalPadConnected: "已连接实体手柄",
    unmute: "取消静音",
    mute: "静音",
    fullscreen: "全屏",
    summonKeyboard: "召唤键盘",
    sensoryMode: "游戏体感",
    idleWarnTip: "检测到长时间未操作，{n} 秒后将自动退出游戏",
    idleContinue: "继续游戏",
    nsInputTitle: "游戏需要输入",
    nsInputHint: "请输入内容后点确认",
    settings: "设置",
    currentRemaining: "当前剩余 {n} 分钟",
    exchangeBeans: "彩豆兑换时长",
    useAddTimeCard: "使用加时卡",
  },
  net: {
    requestFailed: "请求失败",
    errorWithCode: "错误 {code}",
    serverError: "网络错误 {status}",
    timeout: "请求超时",
    networkError: "网络异常",
  },
  controls: {
    selectKeyFirst: "请先选择一个按键",
    saved: "已保存",
    saveFailed: "保存失败",
    selected: "已选中：{name}",
    keyFallback: "按键",
    hint: "拖动按键调整位置，点选后可改大小 / 透明度 / 操作",
    size: "大小 {pct}%",
    opacity: "透明 {pct}%",
    operation: "操作",
    opPress: "按下",
    opDrag: "拖动",
    opLock: "锁定",
    delete: "删除",
    addKey: "添加按键",
    reset: "重置",
    save: "保存",
    addHiddenKey: "添加隐藏的按键",
    noHiddenKeys: "没有被隐藏的按键",
  },
};

export type MessageSchema = typeof messages;
export default messages;
